module.exports = __webpack_public_path__ + "img/10_14.042308ff.png";